import { quickAddActionCreators } from '@app/components/QuickAddModal/modules/quickAdd'
import { connect } from 'react-redux'
import NoSuggestions from '../components/NoSuggestions'

export default connect(
  (state: any) => ({}),
  quickAddActionCreators,
)(NoSuggestions)
